module.exports = __webpack_public_path__ + "img/dominica.6856802b.svg";